

export default function Footer() {
  return (
    <footer className="bg-[#14253D] text-white py-6">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-20">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-5 md:gap-6">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/f9226af7b0c833b6273ae5c168cd92f2/66666c812e06cd99eff1f65da3097ea0.png" 
              alt="VA Jurídico Logo" 
              className="h-16 md:h-20 w-auto"
            />
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-[#B89A5A] font-serif font-semibold mb-2 text-xs md:text-sm">Contacto</h3>
            <ul className="space-y-1 text-xs">
              <li>
                <a
                  href="https://www.google.com/maps/place/Jujuy+76,+X5022FMB+C%C3%B3rdoba/@-31.4131761,-64.1928992,17z/data=!3m1!4b1!4m6!3m5!1s0x9432987f5c9d56bb:0x2cddd95a7463515e!8m2!3d-31.4131807!4d-64.1903243!16s%2Fg%2F11vm144lb3?entry=ttu&g_ep=EgoyMDI2MDIwNC4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-[#B89A5A] transition-colors duration-300 cursor-pointer"
                >
                  Jujuy 76 Oficina 3ºA, Córdoba
                </a>
              </li>
              <li>
                <a href="tel:+5493513495570" className="text-white/70 hover:text-[#B89A5A] transition-colors duration-300 cursor-pointer">
                  +54 351-3495570
                </a>
              </li>
              <li>
                <a href="mailto:abamigovalentina@gmail.com" className="text-white/70 hover:text-[#B89A5A] transition-colors duration-300 cursor-pointer">
                  abamigovalentina@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-5 md:mt-6 pt-4 text-center">
          <p className="text-white/50 text-xs">
            © 2026 VA Jurídico. <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#B89A5A] transition-colors"></a>
          </p>
        </div>
      </div>
    </footer>
  );
}
